import React from 'react';
import styled from 'styled-components';
import Udesk from 'Udesk';
import { PlayBtn } from './PlayBtn';
import { ScoreDetail } from './ScoreDetail';
import { FormatDate } from './UserNode';
import { CorrectBtn, useCorrectBtn } from './CorrectBtn';
import UdeskLocales from 'UdeskLocales';
import ImageViewer from 'src/components/common/ImageViewer';

const PPTNodeWrap = styled.div`
    display: flex;
    justify-content: flex-start;

    & ::selection {
        background-color: rgba(199, 237, 206);
        color: rgba(0, 0, 0, 0.85);
    }

    .udesk-coach-PPT-node-pic {
        display: flex;
        flex-flow: column;
        width: 264px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background-color: #fff;
        margin-right: 16px;
    }

    .udesk-coach-PPT-node-pic-title {
        line-height: 38px;
        padding: 0 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        background-color: #f5f6f8;

        span {
            color: rgba(0, 0, 0, 0.45);

            &:after {
                content: '：';
            }
        }
    }

    .udesk-coach-PPT-node-left {
        flex: 1;
        margin-right: 12px;

        .udesk-coach-PPT-node-title {
            color: rgba(0, 0, 0, 0.65);
            font-size: 12px;
            line-height: 12px;
            margin-bottom: 8px;
        }
        .udesk-coach-PPT-node-content {
            background: #1a6eff;
            border-radius: 4px 0px 4px 4px;
            padding: 10px 12px;
            color: #ffffff;
            font-size: 14px;
            line-height: 22px;
            display: inline-flex;
        }
    }

    .udesk-qa-ui-avatar {
        width: 36px;
        height: 36px;
    }
`;

export const PPT = React.memo(
    React.forwardRef((props: any) => {
        const { traineeWordsResult, startSecond, content, ossKey, showCorrect, ...componentProps } =
            props;

        const { contentText, ...correctBtnProps } = useCorrectBtn({
            content,
            recordId: props.recordId,
            sentenceId: props.id,
        });

        return (
            <PPTNodeWrap>
                <div className="udesk-coach-PPT-node-left">
                    <div className="udesk-coach-PPT-node-title">
                        {Udesk.utils.date.formatDurationWithMillisecond(startSecond)}
                        {showCorrect ? <CorrectBtn {...correctBtnProps} /> : null}
                    </div>
                    <div className="udesk-coach-PPT-node-content">
                        <div>{contentText}</div>
                        <PlayBtn url={ossKey} position="right" />
                    </div>
                    <ScoreDetail data={traineeWordsResult} {...componentProps} width={'100%'} />
                </div>
            </PPTNodeWrap>
        );
    })
);

export const OnePagePPT = React.memo(
    React.forwardRef((props: any) => {
        const {
            traineeWordsResult,
            startSecond,
            content,
            ossKey,
            index,
            nodeName,
            pptUrl,
            showCorrect,
            ...componentProps
        } = props;

        const { contentText, ...correctBtnProps } = useCorrectBtn({
            content,
            recordId: props.recordId,
            sentenceId: props.id,
        });

        return (
            <PPTNodeWrap>
                <div>
                    <div className="udesk-coach-PPT-node-pic">
                        <ImageViewer>
                            <img
                                alt=""
                                style={{ width: 264 }}
                                src={
                                    pptUrl ||
                                    'data:image/png;base64,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'
                                }
                            />
                        </ImageViewer>

                        <div className="udesk-coach-PPT-node-pic-title">
                            <span>
                                {/* 幻灯片 */}
                                {
                                    UdeskLocales['current'].components.coach.dialogue.components.pPT
                                        .slide
                                }
                                {index + 1}
                            </span>
                            {nodeName}
                        </div>
                    </div>
                </div>
                <div className="udesk-coach-PPT-node-left">
                    <div className="udesk-coach-PPT-node-title">
                        <FormatDate startSecond={startSecond} />
                        {showCorrect ? <CorrectBtn {...correctBtnProps} /> : null}
                    </div>
                    <div className="udesk-coach-PPT-node-content">
                        <div>{contentText}</div>
                        <PlayBtn url={ossKey} position="right" />
                    </div>
                    <ScoreDetail data={traineeWordsResult} {...componentProps} width={'100%'} />
                </div>
            </PPTNodeWrap>
        );
    })
);
